import BusinessValueChains from './BusinessValueChains';

export default BusinessValueChains;
